import GUI from "lil-gui";
import { PointName } from "@/data/content";

const debuggingControlsMixin = {
  data() {
    return {
      totalStation: {}
    };
  },
  methods: {
    // debugging UI for tweaking environment map parameters
    initGUI() {
      const gui = new GUI();
      let envFolder = gui.addFolder("Environment Parameters " + PointName.PI);

      envFolder
        .add(this.envParams[PointName.PI], "radius", 100, 2000)
        .onChange(() => {
          if (this.environmentMap) {
            this.environmentMap.radius = this.envParams[PointName.PI].radius;
          }
        });

      envFolder
        .add(this.envParams[PointName.PI], "height", 0, 50)
        .onChange(() => {
          if (this.environmentMap) {
            this.environmentMap.height = this.envParams[PointName.PI].height;
          }
        });

      envFolder
        .add(this.envParams[PointName.PI], "rotation", -Math.PI, Math.PI)
        .onChange(() => {
          if (this.environmentMap) {
            this.environmentMap.mapRotation =
              this.envParams[PointName.PI].rotation;
          }
        });

      envFolder
        .add(this.envParams[PointName.PI], "brightness", 0, 2)
        .name("Brightness")
        .onChange(() => {
          if (this.environmentMap) {
            this.environmentMap.intensity =
              this.envParams[PointName.PI].brightness;
          }
        });
      envFolder = gui.addFolder("Environment Parameters " + PointName.TC);
      envFolder
        .add(this.envParams[PointName.TC], "radius", 100, 2000)
        .onChange(() => {
          if (this.environmentMap) {
            this.environmentMap.radius = this.envParams[PointName.TC].radius;
          }
        });

      envFolder
        .add(this.envParams[PointName.TC], "height", 0, 50)
        .onChange(() => {
          if (this.environmentMap) {
            this.environmentMap.height = this.envParams[PointName.TC].height;
          }
        });

      envFolder
        .add(this.envParams[PointName.TC], "rotation", -Math.PI, Math.PI)
        .onChange(() => {
          if (this.environmentMap) {
            this.environmentMap.mapRotation =
              this.envParams[PointName.TC].rotation;
          }
        });

      envFolder
        .add(this.envParams[PointName.TC], "brightness", 0, 2)
        .name("Brightness")
        .onChange(() => {
          if (this.environmentMap) {
            this.environmentMap.intensity =
              this.envParams[PointName.TC].brightness;
          }
        });

      envFolder.open();
    }
  }
};

export default debuggingControlsMixin;
